import {CONFIG} from '../../appConfig';

const SESSION = 'session/';

export default {
  /**
   * @desc Get current session object, optional param for clearing state of flow specific logic
   * @param {Object} data {params}
   * @returns {Object}
   * @memberof services.gma.session
   * @example
   * const params = {
   *   clean, // *(Boolean)*
   * }
   * services.gma.session.current(opt);
   * // dispatched results stored in `state.gmi.session`
   */
  current(data = {}) {
    const {params = {}} = data;
    return {
      method: 'GET',
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${SESSION}current`,
      params
    };
  },

  /**
   * @desc Get current token from logged in user
   * @param {Object} data {params}
   * @returns {Object}
   * @memberof services.gma.session
   * @example
    * services.gma.session.token(opt);
  */
  token(data = {}) {
    const {params = {}} = data;
    return {
      method: 'GET',
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${SESSION}ec/token`,
      params
    };
  },

  /**
   * @desc Clear session data
   * @returns {Object}
   * @memberof services.gma.session
   * @example 
   *  services.gma.session.clear()
   */
  clear() {
    return {
      method: 'POST',
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${SESSION}clear`
    }
  },

  /**
   * @desc Invalidate user sesssion in GMA
   * @param {Object} data {params}
   * @returns {Object}
   * @memberof services.gma.session
   * @example
    * services.gma.session.invalidate(opt);
  */
  invalidate(data = {}) {
    const {params = {}} = data;
    return {
      method: 'POST',
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${SESSION}invalidate`,
      params
    };
  }
};
